import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'
import parse from 'html-react-parser'

const PAGE_SIZE = 30

class PersonaFisicaComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ...props,
            allPersonasFisicas: [],
            elements: [],
            busqueda: '',
            loading: true,
            sortKey: 'apellidoPaterno', sortAsc: true,
            currentPage: 1,
            // búsqueda rápida por nombre (navega directo al reporte)
            quickSearch: '', quickResults: [], showQuickDrop: false,
        }
        this.goBusqueda = this.goBusqueda.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("READ_PERSONAS_FISICAS")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }
        ElementsDataService.retrieveAllElements("personas-fisicas").then(r => {
            const sorted = this.doSort('apellidoPaterno', true, r.data)
            this.setState({ allPersonasFisicas: r.data, elements: sorted, loading: false })
        })
    }

    goBusqueda() {
        const q = this.state.busqueda.toUpperCase()
        if (q.length < 3) { alert("Debe escribir al menos tres caracteres."); return }
        this.setState({ loading: true })
        ElementsDataService.retrieveSearch(q, "personasFisicas").then(r => {
            if (!r.data.length) alert("Esta búsqueda no arroja resultados.")
            this.setState({ elements: r.data, loading: false, currentPage: 1 })
        })
    }

    clearBusqueda() {
        const sorted = this.doSort(this.state.sortKey, this.state.sortAsc, this.state.allPersonasFisicas)
        this.setState({ busqueda: '', elements: sorted, currentPage: 1 })
    }

    doSort(key, asc, arr) {
        return [...arr].sort((a, b) => {
            const va = (a[key] || '').toString().toLowerCase()
            const vb = (b[key] || '').toString().toLowerCase()
            if (va < vb) return asc ? -1 : 1
            if (va > vb) return asc ? 1 : -1
            return 0
        })
    }

    sortBy(key) {
        const asc = this.state.sortKey === key ? !this.state.sortAsc : true
        this.setState({ elements: this.doSort(key, asc, this.state.elements), sortKey: key, sortAsc: asc, currentPage: 1 })
    }

    highlight(text) {
        const q = this.state.busqueda
        if (!text || q.length < 3) return text || ''
        return parse(String(text).replace(new RegExp(q, 'gi'), m =>
            `<mark style="background:#dbeafe;color:#1d4ed8;border-radius:3px;padding:0 2px">${m}</mark>`
        ))
    }

    render() {
        const { elements, busqueda, loading, sortKey, sortAsc, currentPage,
            quickSearch, quickResults, showQuickDrop } = this.state

        const totalPages = Math.max(1, Math.ceil(elements.length / PAGE_SIZE))
        const page = Math.min(currentPage, totalPages)
        const pageData = elements.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

        const SortIcon = ({ k }) => sortKey !== k
            ? <span style={{ color: '#cbd5e1', marginLeft: 3 }}>↕</span>
            : <span style={{ color: '#3b82f6', marginLeft: 3 }}>{sortAsc ? '↑' : '↓'}</span>

        // Búsqueda rápida local
        const filtQuick = quickSearch.length > 1
            ? this.state.allPersonasFisicas
                .filter(p => `${p.nombre} ${p.apellidoPaterno} ${p.apellidoMaterno} ${p.rfc}`.toLowerCase().includes(quickSearch.toLowerCase()))
                .slice(0, 20)
            : []

        // Avatar initials
        const initials = p => {
            const a = (p.apellidoPaterno || '').charAt(0)
            const n = (p.nombre || '').charAt(0)
            return (a + n).toUpperCase() || '?'
        }
        const avatarColor = (p) => {
            const colors = ['#3b82f6','#8b5cf6','#ec4899','#f59e0b','#10b981','#06b6d4','#6366f1']
            const idx = ((p.apellidoPaterno || '').charCodeAt(0) || 0) % colors.length
            return colors[idx]
        }

        return (
            <div style={S.root}>
                <style>{css}</style>
                <div className="pf-root" style={S.inner}>

                    {/* Header */}
                    <div style={S.header}>
                        <div>
                            <h1 style={S.title}>Personas Físicas</h1>
                            <p style={S.subtitle}>
                                {loading ? 'Cargando...' : `${elements.length} persona${elements.length !== 1 ? 's' : ''} encontrada${elements.length !== 1 ? 's' : ''}`}
                            </p>
                        </div>
                        {AuthenticationService.haveAuthorization("WRITE_PERSONAS_FISICAS") && (
                            <button style={S.btnAdd} onClick={this.props.addElementClicked}>+ Persona Física</button>
                        )}
                    </div>

                    {/* Barra de herramientas */}
                    <div style={S.searchCard}>
                        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                            {/* Búsqueda principal */}
                            <div style={{ flex: 2, minWidth: 200, position: 'relative' }}>
                                <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>🔍</span>
                                <input className="pf-input" style={{ paddingLeft: 36, paddingRight: busqueda ? 36 : 14 }}
                                    type="text" placeholder="Buscar por nombre, apellido o RFC... (Enter)"
                                    value={busqueda}
                                    onChange={e => {
                                        const v = e.target.value.toUpperCase()
                                        this.setState({ busqueda: v })
                                        if (!v) this.clearBusqueda()
                                    }}
                                    onKeyDown={e => { if (e.key === 'Enter') this.goBusqueda() }}
                                />
                                {busqueda && (
                                    <button onClick={() => this.clearBusqueda()} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '1rem' }}>✕</button>
                                )}
                            </div>

                            {/* Búsqueda rápida → navega directo */}
                            <div style={{ flex: 1, minWidth: 200, position: 'relative' }}>
                                <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>👤</span>
                                <input className="pf-input" style={{ paddingLeft: 36 }}
                                    type="text" placeholder="Ir directo a persona..."
                                    value={quickSearch}
                                    onChange={e => this.setState({ quickSearch: e.target.value, showQuickDrop: true })}
                                    onFocus={() => this.setState({ showQuickDrop: true })}
                                    onBlur={() => setTimeout(() => this.setState({ showQuickDrop: false }), 150)}
                                />
                                {showQuickDrop && quickSearch.length > 1 && (
                                    <div className="pf-dropdown">
                                        {filtQuick.length === 0
                                            ? <div style={{ padding: '10px 14px', color: '#94a3b8', fontSize: '0.8rem' }}>Sin resultados</div>
                                            : filtQuick.map(p => (
                                                <div key={p.id} className="pf-drop-item"
                                                    onMouseDown={() => this.props.history.push(`/personas-fisicas/reportes/${p.id}`)}>
                                                    <div style={{ width: 28, height: 28, borderRadius: '50%', background: avatarColor(p), color: 'white', fontSize: '0.65rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{initials(p)}</div>
                                                    <div>
                                                        <div style={{ fontWeight: 600, fontSize: '0.82rem' }}>{p.apellidoPaterno} {p.apellidoMaterno}, {p.nombre}</div>
                                                        <div style={{ fontSize: '0.68rem', color: '#94a3b8', fontFamily: 'monospace' }}>{p.rfc}</div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                )}
                            </div>

                            <button style={S.btnSearch} onClick={this.goBusqueda}>Buscar</button>
                        </div>
                    </div>

                    {/* Tabla */}
                    <div style={S.tableCard}>
                        {loading ? (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
                                <div className="pf-spinner" />
                            </div>
                        ) : (
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th className="pf-th" style={{ width: 44, textAlign: 'center' }}>#</th>
                                            <th className="pf-th" style={{ width: 44 }}></th>
                                            <th className="pf-th pf-sortable" onClick={() => this.sortBy('apellidoPaterno')}>Ap. Paterno <SortIcon k="apellidoPaterno" /></th>
                                            <th className="pf-th pf-sortable" onClick={() => this.sortBy('apellidoMaterno')}>Ap. Materno <SortIcon k="apellidoMaterno" /></th>
                                            <th className="pf-th pf-sortable" onClick={() => this.sortBy('nombre')}>Nombre(s) <SortIcon k="nombre" /></th>
                                            <th className="pf-th pf-sortable" onClick={() => this.sortBy('rfc')}>RFC <SortIcon k="rfc" /></th>
                                            {AuthenticationService.haveAuthorization("WRITE_PERSONAS_FISICAS") && <th className="pf-th" style={{ width: 40 }}></th>}
                                            {AuthenticationService.haveAuthorization("DELETE_PERSONAS_FISICAS") && <th className="pf-th" style={{ width: 40 }}></th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pageData.length === 0 ? (
                                            <tr><td colSpan={8} style={{ textAlign: 'center', padding: '48px 0', color: '#94a3b8', fontSize: '0.85rem' }}>
                                                Sin resultados. Ajusta el término de búsqueda.
                                            </td></tr>
                                        ) : pageData.map((el, i) => {
                                            const n = (page - 1) * PAGE_SIZE + i + 1
                                            return (
                                                <tr key={el.id} className="pf-tr">
                                                    <td className="pf-td" style={{ textAlign: 'center', color: '#94a3b8', fontWeight: 600, fontSize: '0.78rem' }}>{n}</td>
                                                    <td className="pf-td" style={{ paddingRight: 4 }}>
                                                        <div style={{ width: 32, height: 32, borderRadius: '50%', background: avatarColor(el), color: 'white', fontSize: '0.68rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            {initials(el)}
                                                        </div>
                                                    </td>
                                                    <td className="pf-td" style={{ fontWeight: 600 }}>{this.highlight(el.apellidoPaterno)}</td>
                                                    <td className="pf-td">{this.highlight(el.apellidoMaterno)}</td>
                                                    <td className="pf-td">{this.highlight(el.nombre)}</td>
                                                    <td className="pf-td">
                                                        <Link to={`/personas-fisicas/reportes/${el.id}`} className="pf-link">
                                                            <span style={{ fontFamily: 'monospace', fontSize: '0.82rem' }}>{this.highlight(el.rfc)}</span>
                                                        </Link>
                                                    </td>
                                                    {AuthenticationService.haveAuthorization("WRITE_PERSONAS_FISICAS") && (
                                                        <td className="pf-td" style={{ textAlign: 'center' }}>
                                                            <button className="btn-edit" onClick={() => this.props.updateElementClicked(el.id)}>✏️</button>
                                                        </td>
                                                    )}
                                                    {AuthenticationService.haveAuthorization("DELETE_PERSONAS_FISICAS") && (
                                                        <td className="pf-td" style={{ textAlign: 'center' }}>
                                                            <button className="btn-del" onClick={() => this.props.deleteElementClicked(el.id)}>🗑</button>
                                                        </td>
                                                    )}
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Paginación */}
                        {!loading && totalPages > 1 && (
                            <div style={S.pagination}>
                                <span style={S.pageInfo}>Mostrando {(page-1)*PAGE_SIZE+1}–{Math.min(page*PAGE_SIZE, elements.length)} de {elements.length}</span>
                                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                    <button className="page-btn" onClick={() => this.setState({ currentPage: 1 })} disabled={page===1}>«</button>
                                    <button className="page-btn" onClick={() => this.setState({ currentPage: page-1 })} disabled={page===1}>‹</button>
                                    {getPageNumbers(page, totalPages).map((p, i) =>
                                        p === '...'
                                            ? <span key={i} style={{ padding: '0 4px', alignSelf: 'center', color: '#94a3b8' }}>…</span>
                                            : <button key={p} className={`page-btn${page===p?' active':''}`} onClick={() => this.setState({ currentPage: p })}>{p}</button>
                                    )}
                                    <button className="page-btn" onClick={() => this.setState({ currentPage: page+1 })} disabled={page===totalPages}>›</button>
                                    <button className="page-btn" onClick={() => this.setState({ currentPage: totalPages })} disabled={page===totalPages}>»</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

function getPageNumbers(current, total) {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
    if (current <= 4) return [1, 2, 3, 4, 5, '...', total]
    if (current >= total - 3) return [1, '...', total-4, total-3, total-2, total-1, total]
    return [1, '...', current-1, current, current+1, '...', total]
}

const css = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
    .pf-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
    .pf-input {
        width: 100%; padding: 9px 14px; background: white; border: 1px solid #e2e8f0;
        border-radius: 10px; font-size: 0.875rem; color: #334155; outline: none; transition: all 0.2s;
        font-family: 'Inter', sans-serif;
    }
    .pf-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
    .pf-th { padding: 9px 14px; text-align: left; font-size: 0.68rem; font-weight: 700; color: #64748b; letter-spacing: 0.7px; text-transform: uppercase; border-bottom: 1px solid #e2e8f0; background: #f8fafc; white-space: nowrap; }
    .pf-sortable { cursor: pointer; user-select: none; }
    .pf-sortable:hover { color: #3b82f6; background: #f0f7ff; }
    .pf-tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
    .pf-tr:hover td { background: #f8faff !important; }
    .pf-td { padding: 10px 14px; font-size: 0.83rem; color: #334155; vertical-align: middle; }
    .pf-link { color: #3b82f6; text-decoration: none; font-weight: 600; }
    .pf-link:hover { text-decoration: underline; }
    .pf-dropdown {
        position: absolute; top: calc(100% + 4px); left: 0; right: 0;
        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
        z-index: 200; max-height: 220px; overflow-y: auto;
        box-shadow: 0 8px 24px rgba(0,0,0,0.1);
    }
    .pf-drop-item { padding: 9px 14px; cursor: pointer; font-size: 0.82rem; color: #334155; transition: background 0.12s; display: flex; align-items: center; gap: 10px; }
    .pf-drop-item:hover { background: #eff6ff; }
    .btn-edit { padding: 4px 9px; border: 1px solid #e2e8f0; border-radius: 7px; background: white; cursor: pointer; font-size: 0.72rem; color: #64748b; transition: all 0.15s; }
    .btn-edit:hover { border-color: #3b82f6; color: #3b82f6; background: #eff6ff; }
    .btn-del { padding: 4px 9px; border: 1px solid #fee2e2; border-radius: 7px; background: white; cursor: pointer; font-size: 0.72rem; color: #ef4444; transition: all 0.15s; }
    .btn-del:hover { background: #fef2f2; border-color: #ef4444; }
    .page-btn { min-width: 32px; height: 32px; padding: 0 8px; border: 1px solid #e2e8f0; border-radius: 7px; background: white; cursor: pointer; font-size: 0.8rem; color: #475569; transition: all 0.15s; font-family: 'Inter', sans-serif; display: flex; align-items: center; justify-content: center; }
    .page-btn:hover:not(:disabled) { border-color: #3b82f6; color: #3b82f6; }
    .page-btn.active { background: #3b82f6; color: white; border-color: #3b82f6; font-weight: 700; }
    .page-btn:disabled { opacity: 0.4; cursor: not-allowed; }
    @keyframes spin { to { transform: rotate(360deg); } }
    .pf-spinner { width: 28px; height: 28px; border: 3px solid #e2e8f0; border-top-color: #3b82f6; border-radius: 50%; animation: spin 0.7s linear infinite; }
`

const S = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 1100, margin: '0 auto' },
    header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 },
    title: { margin: '0 0 4px', fontSize: '1.5rem', fontWeight: 700, color: '#0f172a' },
    subtitle: { margin: 0, fontSize: '0.82rem', color: '#94a3b8' },
    btnAdd: { padding: '9px 16px', background: 'linear-gradient(135deg, #2563eb, #3b82f6)', border: 'none', borderRadius: 10, color: 'white', fontWeight: 600, fontSize: '0.84rem', cursor: 'pointer', boxShadow: '0 4px 12px rgba(59,130,246,0.3)', fontFamily: "'Inter', sans-serif" },
    btnSearch: { padding: '9px 18px', background: '#0f172a', border: 'none', borderRadius: 10, color: 'white', fontWeight: 600, fontSize: '0.84rem', cursor: 'pointer', fontFamily: "'Inter', sans-serif", whiteSpace: 'nowrap' },
    searchCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, padding: '16px 20px', marginBottom: 14, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    tableCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    pagination: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', borderTop: '1px solid #f1f5f9', flexWrap: 'wrap', gap: 10 },
    pageInfo: { fontSize: '0.78rem', color: '#94a3b8' },
}

export default PersonaFisicaComponent
